import { FC, useEffect } from 'react'
import { UnlicensedBlock } from './components/UnlicensedBlock/UnlicensedBlock'
import { LicensedBlock } from './components/LicensedBlock/LicensedBlock'
import { useStore } from 'effector-react'
import { $license, $licenseIsLoading, getLicenseFx } from './store/getLicense'
import { LoaderWrapper } from '../../../components/Wrappers/LoaderWrapper'

export const SettingsLicenseWidget: FC = () => {
  const license = useStore($license)
  const licenseIsLoading = useStore($licenseIsLoading)

  useEffect(() => {
    getLicenseFx()
  }, [])

  return (
    <LoaderWrapper loading={licenseIsLoading}>
      {license.isActivated ? <LicensedBlock /> : <UnlicensedBlock />}
    </LoaderWrapper>
  )
}
